// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Client V2 common imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

class ContactModelRecord extends Immutable.Record({
  complete: String(),
  type: String('contact'),
  photo: String(),
  names: Immutable.List() // [ String(), ... ]
}) {
  // No methods
}

ContactModelRecord.reviver = keyedReviver(ContactModelRecord, {
  names: defaultReviver
})

ContactModelRecord.propTypes = {
  complete: PropTypes.string,
  type: PropTypes.string,
  photo: PropTypes.string,
  names: PropTypes.arrayOf(PropTypes.string)
}

module.exports = ContactModelRecord
